import { type PropsWithChildren } from "react";

import { cx } from "../cx";
import { DOM_IDS } from "../defaults";

interface BodyProps extends PropsWithChildren {
  className?: string;
}

export const Body = ({ children, className }: Readonly<BodyProps>) => (
  <div
    id={DOM_IDS.workspaceBody}
    data-testid="circle-ai-shell-workspace-body"
    className={cx("flex min-h-0 flex-1 flex-col overflow-auto", className)}
  >
    {children}
  </div>
);

Body.displayName = "CircleAIAppShell.Layout.Workspace.Body";
